import { upsertResourceFilters } from '@dispatch/shared/services';
import { ResourcesListFilter } from '@dispatch/shared/types';
import { useMutate } from '../api/useMutate';

export const useUpsertResourceListFilter = (
  responseFn: (data: { success: boolean }) => void | Promise<unknown>,
  userId: string
) => {
  const { mutate, error, status } = useMutate(
    ['upsert-resource-filter'],
    (data: ResourcesListFilter) =>
      upsertResourceFilters(
        {
          ...data,
          userId,
        },
        userId
      ),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    upsertResourceFilters: mutate,
    upsertTaskFilterError: error,
    upsertTaskFilterStatus: status,
  };
};
